import { gql } from 'graphql-tag';

import { AccordionFragment } from '@/components/common/blocks/Accordion';
import { AddOnTrainingChapterFragment } from '@/components/common/blocks/AddOnTrainingChapter';
import { AlsoBoughtFragment } from '@/components/common/blocks/AlsoBought';
import { AppCtaFragment } from '@/components/common/blocks/AppCta';
import { ArticleChapterFragment } from '@/components/common/blocks/ArticleChapter';
import { ArticleRowSlideFragment } from '@/components/common/blocks/ArticleRowSlide';
import { AsSeenInFragment } from '@/components/common/blocks/AsSeenIn';
import { CampaignGridFragment } from '@/components/common/blocks/CampaignGrid';
import { CenteredContentFragment } from '@/components/common/blocks/CenteredContent';
import { CollectionInformationFragment } from '@/components/common/blocks/CollectionInformation';
import { LinksDisplayFragment } from '~/components/common/blocks/LinksDisplay';
import { SectionHeadingFragment } from '~/components/common/blocks/SectionHeading';
import { CompareContentSliderFragment } from '@/components/common/blocks/CompareContentSlider';
import { CompareTableFragment } from '@/components/common/blocks/CompareTable';
import { ContactBlockFragment } from '@/components/common/blocks/ContactBlock';
import { ContentListFragment } from '@/components/common/blocks/ContentList';
import { ContentRecommendationSlideFragment } from '@/components/common/blocks/ContentRecommendationSlide';
import { ContentWithIconsFragment } from '@/components/common/blocks/ContentWithIcons';
import { ConversionAreaOneFragment } from '@/components/common/blocks/ConversionAreaOne';
import { CopyTextFragment } from '@/components/common/blocks/CopyText';
import { CourseContentFragment } from '@/components/common/blocks/CourseContent';
import { CourseConversionBannerFragment } from '@/components/common/blocks/CourseConversionBanner';
import { CrossSellFragment } from '@/components/common/blocks/CrossSell';
import { ExerciseFragment } from '@/components/common/blocks/Exercise';
import { ExerciseRoutineCardsSliderWithTextFragment } from '@/components/common/blocks/ExerciseRoutineCardsSliderWithText';
import { ExpertDetailsListingFragment } from '@/components/common/blocks/ExpertDetailsListing';
import { ExploreMoreFragment } from '@/components/common/blocks/ExploreMore';
import { FeaturedArticlesSlideFragment } from '@/components/common/blocks/FeaturedArticlesSlide';
import { FeaturedExpertsFragment } from '@/components/common/blocks/FeaturedExperts';
import { FeatureListFragment } from '@/components/common/blocks/FeatureList';
import { FeaturesRotationFragment } from '@/components/common/blocks/FeaturesRotation';
import { FeaturesWithIconsFragment } from '@/components/common/blocks/FeaturesWithIcons';
import { FiftyFiftyTeaserFragment } from '~/components/common/blocks/FiftyFiftyTeaser';
import { FindTrainingFragment } from '@/components/common/blocks/FindTraining';
import { FixedBoxImagesFragment } from '@/components/common/blocks/FixedBoxImages';
import { FixedBoxTopicFeatureFragment } from '@/components/common/blocks/FixedBoxTopicFeature';
import { FormLinkFragment } from '@/components/common/blocks/FormLink';
import { FullWidthAutoplayVideoFragment } from '@/components/common/blocks/FullWidthAutoplayVideo';
import { FullWidthBrandFragment } from '@/components/common/blocks/FullWidthBrand';
import { FullWidthTeaserFragment } from '~/components/common/blocks/FullWidthTeaser';
import { FullwidthTopicFeatureBarsFragment } from '@/components/common/blocks/FullwidthTopicFeatureBars';
import { GalleryFragment } from '@/components/common/blocks/Gallery';
import { GenericIframeFragment } from '@/components/common/blocks/GenericIframe';
import { HeroProductFragment } from '@/components/common/blocks/HeroProduct';
import { ImageOrVideoFragment } from '@/components/common/blocks/ImageOrVideo';
import { ImageTextFragment } from '@/components/common/blocks/ImageText';
import { ImageTextHoverFragment } from '@/components/common/blocks/ImageTextHover';
import { ImageTitleFeatureFragment } from '@/components/common/blocks/ImageTitleFeature';
import { CtaBlockFragment } from '~/components/common/blocks/CtaBlock';
import { InsuranceReimbursementFragment } from '@/components/common/blocks/InsuranceReimbursement';
import { JobsFragment } from '@/components/common/blocks/Jobs';
import { LargeExerciseRoutineSliderFragment } from '@/components/common/blocks/LargeExerciseRoutineSlider';
import { LargeStoryFeatureWithBarsFragment } from '@/components/common/blocks/LargeStoryFeatureWithBars';
import { LargeTopicFeatureFragment } from '@/components/common/blocks/LargeTopicFeature';
import { MediumTopicFeatureFragment } from '@/components/common/blocks/MediumTopicFeature';
import { MovingFullWidthImagesFragment } from '@/components/common/blocks/MovingFullWidthImages';
import { NewsletterSignupFormFragment } from '@/components/common/blocks/NewsletterSignupForm';
import { NumberedImageFragment } from '@/components/common/blocks/NumberedImage';
import { NumbersOnBlackBackgroundFragment } from '@/components/common/blocks/NumbersOnBlackBackground';
import { ParallaxImagesFragment } from '@/components/common/blocks/ParallaxImages';
import { ProductGridFragment } from '@/components/common/blocks/ProductGrid';
import { ProductInformationFragment } from '@/components/common/blocks/ProductInformation';
import { ProductReviewsFragment } from '@/components/common/blocks/ProductReviews';
import { ProductSliderFragment } from '@/components/common/blocks/ProductSlider';
import { RelatedProductsFragment } from '@/components/common/blocks/RelatedProducts';
import { RoutineCardsSliderFragment } from '@/components/common/blocks/RoutineCardsSlider';
import { ShareThisArticleFragment } from '@/components/common/blocks/ShareThisArticle';
import { SingleSocialMediaPostFragment } from '~/components/common/blocks/SingleSocialMediaPost';
import { SmallInstructionFragment } from '@/components/common/blocks/SmallInstruction';
import { SmallStoryFeaturesWithBarsFragment } from '@/components/common/blocks/SmallStoryFeaturesWithBars';
import { SmallTopicFeatureBarsFragment } from '@/components/common/blocks/SmallTopicFeatureBars';
import { SmallTopicFeatureBoxFragment } from '@/components/common/blocks/SmallTopicFeatureBox';
import { SmallTopicFeatureFragment } from '@/components/common/blocks/SmallTopicFeature';
import { SocialFeatureFragment } from '@/components/common/blocks/SocialFeature';
import { SplitContentSliderFragment } from '@/components/common/blocks/SplitContentSlider';
import { StoryTeaserBlackFragment } from '@/components/common/blocks/StoryTeaserBlack';
import { TeaserWithMultipleCtasFragment } from '@/components/common/blocks/TeaserWithMultipleCtas';
import { TestimonialFragment } from '@/components/common/blocks/Testimonial';
import { TextLeftImageRightFragment } from '@/components/common/blocks/TextLeftImageRight';
import { TimelineFragment } from '@/components/common/blocks/Timeline';
import { TwoPortraitImagesFragment } from '@/components/common/blocks/TwoPortraitImages';
import { UpsellFragment } from '@/components/common/blocks/Upsell';
import { ValueRotationFragment } from '@/components/common/blocks/ValueRotation';
import { VideoFeatureFragment } from '@/components/common/blocks/VideoFeature';
import { VideoRotationFragment } from '@/components/common/blocks/VideoRotation';
import { VideoWithDescriptionFragment } from '@/components/common/blocks/VideoWithDescription';

export const ContentBlocksMatrixFragment = gql`
  fragment ContentBlocksMatrixFragment on contentBlocks_MatrixField {
    __typename
    ...AccordionFragment
    ...AddOnTrainingChapterFragment
    ...AlsoBoughtFragment
    ...AppCtaFragment
    ...ArticleChapterFragment
    ...ArticleRowSlideFragment
    ...AsSeenInFragment
    ...CampaignGridFragment
    ...CenteredContentFragment
    ...CollectionInformationFragment
    ...LinksDisplayFragment
    ...SectionHeadingFragment
    ...CompareContentSliderFragment
    ...CompareTableFragment
    ...ContactBlockFragment
    ...ContentListFragment
    ...ContentRecommendationSlideFragment
    ...ContentWithIconsFragment
    ...ConversionAreaOneFragment
    ...CopyTextFragment
    ...CourseContentFragment
    ...CourseConversionBannerFragment
    ...CrossSellFragment
    ...ExerciseFragment
    ...ExerciseRoutineCardsSliderWithTextFragment
    ...ExpertDetailsListingFragment
    ...ExploreMoreFragment
    ...FeaturedArticlesSlideFragment
    ...FeaturedExpertsFragment
    ...FeatureListFragment
    ...FeaturesRotationFragment
    ...FeaturesWithIconsFragment
    ...FiftyFiftyTeaserFragment
    ...FindTrainingFragment
    ...FixedBoxImagesFragment
    ...FixedBoxTopicFeatureFragment
    ...FormLinkFragment
    ...FullWidthAutoplayVideoFragment
    ...FullWidthBrandFragment
    ...FullWidthTeaserFragment
    ...FullwidthTopicFeatureBarsFragment
    ...GalleryFragment
    ...GenericIframeFragment
    ...HeroProductFragment
    ...ImageOrVideoFragment
    ...ImageTextFragment
    ...ImageTextHoverFragment
    ...ImageTitleFeatureFragment
    ...CtaBlockFragment
    ...InsuranceReimbursementFragment
    ...JobsFragment
    ...LargeExerciseRoutineSliderFragment
    ...LargeStoryFeatureWithBarsFragment
    ...LargeTopicFeatureFragment
    ...MediumTopicFeatureFragment
    ...MovingFullWidthImagesFragment
    ...NewsletterSignupFormFragment
    ...NumberedImageFragment
    ...NumbersOnBlackBackgroundFragment
    ...ParallaxImagesFragment
    ...ProductGridFragment
    ...ProductInformationFragment
    ...ProductReviewsFragment
    ...ProductSliderFragment
    ...RelatedProductsFragment
    ...RoutineCardsSliderFragment
    ...ShareThisArticleFragment
    ...SingleSocialMediaPostFragment
    ...SmallInstructionFragment
    ...SmallStoryFeaturesWithBarsFragment
    ...SmallTopicFeatureBarsFragment
    ...SmallTopicFeatureBoxFragment
    ...SmallTopicFeatureFragment
    ...SocialFeatureFragment
    ...SplitContentSliderFragment
    ...StoryTeaserBlackFragment
    ...TeaserWithMultipleCtasFragment
    ...TestimonialFragment
    ...TextLeftImageRightFragment
    ...TimelineFragment
    ...TwoPortraitImagesFragment
    ...UpsellFragment
    ...ValueRotationFragment
    ...VideoFeatureFragment
    ...VideoRotationFragment
    ...VideoWithDescriptionFragment
  }
  # MARK: fragment imports
  ${AccordionFragment}
  ${AddOnTrainingChapterFragment}
  ${AlsoBoughtFragment}
  ${AppCtaFragment}
  ${ArticleChapterFragment}
  ${ArticleRowSlideFragment}
  ${AsSeenInFragment}
  ${CampaignGridFragment}
  ${CenteredContentFragment}
  ${CollectionInformationFragment}
  ${LinksDisplayFragment}
  ${SectionHeadingFragment}
  ${CompareContentSliderFragment}
  ${CompareTableFragment}
  ${ContactBlockFragment}
  ${ContentListFragment}
  ${ContentRecommendationSlideFragment}
  ${ContentWithIconsFragment}
  ${ConversionAreaOneFragment}
  ${CopyTextFragment}
  ${CourseContentFragment}
  ${CourseConversionBannerFragment}
  ${CrossSellFragment}
  ${ExerciseFragment}
  ${ExerciseRoutineCardsSliderWithTextFragment}
  ${ExpertDetailsListingFragment}
  ${ExploreMoreFragment}
  ${FeaturedArticlesSlideFragment}
  ${FeaturedExpertsFragment}
  ${FeatureListFragment}
  ${FeaturesRotationFragment}
  ${FeaturesWithIconsFragment}
  ${FiftyFiftyTeaserFragment}
  ${FindTrainingFragment}
  ${FixedBoxImagesFragment}
  ${FixedBoxTopicFeatureFragment}
  ${FormLinkFragment}
  ${FullWidthAutoplayVideoFragment}
  ${FullWidthBrandFragment}
  ${FullWidthTeaserFragment}
  ${FullwidthTopicFeatureBarsFragment}
  ${GalleryFragment}
  ${GenericIframeFragment}
  ${HeroProductFragment}
  ${ImageOrVideoFragment}
  ${ImageTextFragment}
  ${ImageTextHoverFragment}
  ${ImageTitleFeatureFragment}
  ${CtaBlockFragment}
  ${InsuranceReimbursementFragment}
  ${JobsFragment}
  ${LargeExerciseRoutineSliderFragment}
  ${LargeStoryFeatureWithBarsFragment}
  ${LargeTopicFeatureFragment}
  ${MediumTopicFeatureFragment}
  ${MovingFullWidthImagesFragment}
  ${NewsletterSignupFormFragment}
  ${NumberedImageFragment}
  ${NumbersOnBlackBackgroundFragment}
  ${ParallaxImagesFragment}
  ${ProductGridFragment}
  ${ProductInformationFragment}
  ${ProductReviewsFragment}
  ${ProductSliderFragment}
  ${RelatedProductsFragment}
  ${RoutineCardsSliderFragment}
  ${ShareThisArticleFragment}
  ${SingleSocialMediaPostFragment}
  ${SmallInstructionFragment}
  ${SmallStoryFeaturesWithBarsFragment}
  ${SmallTopicFeatureBarsFragment}
  ${SmallTopicFeatureBoxFragment}
  ${SmallTopicFeatureFragment}
  ${SocialFeatureFragment}
  ${SplitContentSliderFragment}
  ${StoryTeaserBlackFragment}
  ${TeaserWithMultipleCtasFragment}
  ${TestimonialFragment}
  ${TextLeftImageRightFragment}
  ${TimelineFragment}
  ${TwoPortraitImagesFragment}
  ${UpsellFragment}
  ${ValueRotationFragment}
  ${VideoFeatureFragment}
  ${VideoRotationFragment}
  ${VideoWithDescriptionFragment}
`;
